<template>
  <div class="box">
    <div v-if="label !== ' '">
      <h3>{{ label }}</h3>
      <br />
    </div>
    <div v-if="verification">
      <div class="address-capture">
        <div class="columns is-multiline">
          <div class="column is-6">
            <div class="field">
              <label class="label">Address Line 1<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control">
                <input :name="validationName + 'address1'" v-validate="{ 'required': required, 'address_starts_with_number': true }" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'address1') }" :data-vv-scope="scope" data-vv-as="address line 1" type="text" placeholder="Address Line 1" v-model="internalValue.address1">
                <span v-show="errors.has(validationName + 'address1')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'address1')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'address1') }}
                </span>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Address Line 2</label>
              <div class="control">
                <input :name="validationName + 'address2'" :class="{ 'input': true, 'is-danger': errors.has('address2') }" type="text" placeholder="Address Line 2" v-model="internalValue.address2">
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">City<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control">
                <input :name="validationName + 'city'" v-validate="{ 'required': required, 'max': 20 }" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'city') }" :data-vv-scope="scope" data-vv-as="city" type="text" placeholder="City" v-model="internalValue.city">
                <span v-show="errors.has(validationName + 'city')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'city')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'city') }}
                </span>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">State<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control">
                <multiselect
                  :multiple="false"
                  :name="validationName + 'state'"
                  v-validate="{ 'required': required }"
                  :class="{ 'is-danger': errors.has(validationName + 'state') }"
                  :data-vv-scope="scope"
                  data-vv-as="state"
                  placeholder="Select State"
                  label="name"
                  track-by="id"
                  :options="stateOptions"
                  :searchable="true"
                  v-model="selectedState">
                </multiselect>
                <span v-show="errors.has(validationName + 'state')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'state')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'state') }}
                </span>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Zip Code<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control">
                <input :name="validationName + 'postalCode'" v-validate="{ 'required': required, 'max': 5 }" :class="{ 'input': true, 'is-danger': errors.has('postalCode') }" :data-vv-scope="scope" data-vv-as="postal code" type="text" placeholder="Zip Code" v-model="internalValue.postalCode">
                <span v-show="errors.has(validationName + 'postalCode')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'postalCode')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'postalCode') }}
                </span>
                <pop-fill-control v-if="popFillData" title="Click to restore zip code" :fillableValue="popFillData.postalCode" :onFillAction="onRestorePostalCode"></pop-fill-control>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Country<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control">
                <input :name="validationName + 'country'" v-validate="{ 'required': required }" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'country') }" :disabled="true" :data-vv-scope="scope" data-vv-as="country" type="text" placeholder="Country" v-model="internalValue.country">
                <span v-show="errors.has(validationName + 'country')" class="help is-danger"><i v-show="errors.has(validationName + 'country')" class="fas fa-exclamation-triangle"></i> {{ errors.first(validationName + 'country') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="supplierVerification">
      <div class="address-capture">
        <div class="columns is-multiline">
          <div class="column is-6">
            <div class="field">
              <label class="label">Address Line 1<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control">
                <input :name="validationName + 'address1'" v-validate="{ 'required': required, 'address_starts_with_number': true }" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'address1') }" :data-vv-scope="scope" data-vv-as="address line 1" type="text" placeholder="Address Line 1" v-model="internalValue.address1">
                <span v-show="errors.has(validationName + 'address1')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'address1')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'address1') }}
                </span>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Address Line 2</label>
              <div class="control">
                <input :name="validationName + 'address2'" :class="{ 'input': true, 'is-danger': errors.has('address2') }" type="text" placeholder="Address Line 2" v-model="internalValue.address2">
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">City<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control">
                <input :name="validationName + 'city'" v-validate="{ 'required': required, 'max': 20 }" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'city') }" :data-vv-scope="scope" data-vv-as="city" type="text" placeholder="City" v-model="internalValue.city">
                <span v-show="errors.has(validationName + 'city')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'city')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'city') }}
                </span>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">State<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control">
                <multiselect
                  :multiple="false"
                  :name="validationName + 'state'"
                  v-validate="{ 'required': required }"
                  :class="{ 'is-danger': errors.has(validationName + 'state') }"
                  :data-vv-scope="scope"
                  data-vv-as="state"
                  placeholder="Select State"
                  label="name"
                  track-by="id"
                  :options="stateOptions"
                  :searchable="true"
                  v-model="selectedState">
                </multiselect>
                <span v-show="errors.has(validationName + 'state')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'state')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'state') }}
                </span>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Zip Code<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control">
                <input :name="validationName + 'postalCode'" v-validate="{ 'required': required, 'max': 5 }" :class="{ 'input': true, 'is-danger': errors.has('postalCode') }" :data-vv-scope="scope" data-vv-as="postal code" type="text" placeholder="Zip Code" v-model="internalValue.postalCode">
                <span v-show="errors.has(validationName + 'postalCode')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'postalCode')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'postalCode') }}
                </span>
                <pop-fill-control v-if="popFillData" title="Click to restore zip code" :fillableValue="popFillData.postalCode" :onFillAction="onRestorePostalCode"></pop-fill-control>
              </div>
            </div>
          </div>
          <div class="column is-12">
            <div class="field">
              <label class="label">Country<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control">
                <input :name="validationName + 'country'" v-validate="{ 'required': required }" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'country') }" :disabled="true" :data-vv-scope="scope" data-vv-as="country" type="text" placeholder="Country" v-model="internalValue.country">
                <span v-show="errors.has(validationName + 'country')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'country')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'country') }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="columns">
        <div class="column is-10">
          <div class="field" v-if="!isSpouse && previousCustomerAddresses.length > 0">
            <label class="label">Select Prior Addresses</label>
            <div class="control">
              <multiselect
                :multiple="false"
                :name="validationName + 'previousAddress'"
                v-validate="{ 'required': false }"
                placeholder="Select Prior Address"
                label="fullAddress"
                track-by="id"
                :options="previousCustomerAddresses"
                :searchable="true"
                v-model="selectedAddress">
              </multiselect>
            </div>
          </div>
        </div>
        <div class="column is-2" style="align-content: end;">
          <div class="is-pulled-right">
            <b-button icon-left="fa fa-lg fa-minus-circle" class="customButtons is-pulled-right has-text-danger" type="button" inverted @click="removeAddress()">Remove</b-button>
          </div>
        </div>
      </div>
      <div class="address-capture">
        <div class="columns is-multiline">
          <div class="column is-6">
            <div class="field">
              <label class="label">Address Line 1<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control">
                <input :name="validationName + 'address1'" v-validate="{ 'required': required, 'address_starts_with_number': true }" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'address1') }" :data-vv-scope="scope" data-vv-as="address line 1" type="text" placeholder="Address Line 1" v-model="internalValue.address1">
                <span v-show="errors.has(validationName + 'address1')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'address1')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'address1') }}
                </span>
                <pop-fill-control v-if="popFillData" title="Click to copy address1" :fillableValue="popFillData.address1" :onFillAction="onRestoreAddress1"></pop-fill-control>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Address Line 2</label>
              <div class="control">
                <input :name="validationName + 'address2'" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'address2') }" type="text" placeholder="Address Line 2" v-model="internalValue.address2">
              </div>
              <pop-fill-control v-if="popFillData" title="Click to copy address2" :fillableValue="popFillData.address2" :onFillAction="onRestoreAddress2"></pop-fill-control>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">City<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control">
                <input :name="validationName + 'city'" v-validate="{ 'required': required, 'max': 20 }" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'city') }" :data-vv-scope="scope" data-vv-as="city" type="text" placeholder="City" v-model="internalValue.city">
                <span v-show="errors.has(validationName + 'city')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'city')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'city') }}
                </span>
                <pop-fill-control v-if="popFillData" title="Click to copy city" :fillableValue="popFillData.city" :onFillAction="onRestoreCity"></pop-fill-control>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">State<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control">
                <multiselect
                  :multiple="false"
                  :name="validationName + 'state'"
                  v-validate="{ 'required': required }"
                  :class="{ 'is-danger': errors.has(validationName + 'state') }"
                  :data-vv-scope="scope"
                  data-vv-as="state"
                  placeholder="Select State"
                  label="name"
                  track-by="id"
                  :options="stateOptions"
                  :searchable="true"
                  v-model="selectedState">
                </multiselect>
                <span v-show="errors.has(validationName + 'state')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'state')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'state') }}
                </span>
                <pop-fill-control v-if="popFillData" title="Click to copy state" :fillableValue="popFillData.state" :onFillAction="onRestoreState"></pop-fill-control>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Zip Code<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control">
                <input :name="validationName + 'postalCode'" v-validate="{ 'required': required, 'max': 5 }" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'postalCode') }" :data-vv-scope="scope" data-vv-as="postal code" type="text" placeholder="Zip Code" v-model="internalValue.postalCode">
                <span v-show="errors.has(validationName + 'postalCode')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'postalCode')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'postalCode') }}
                </span>
                <pop-fill-control v-if="popFillData" title="Click to copy zip code" :fillableValue="popFillData.postalCode" :onFillAction="onRestorePostalCode"></pop-fill-control>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Country<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control">
                <input :name="validationName + 'country'" v-validate="{ 'required': required }" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'country') }" :disabled="true" :data-vv-scope="scope" data-vv-as="country" type="text" placeholder="Country" v-model="internalValue.country">
                <span v-show="errors.has(validationName + 'country')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'country')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'country') }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-multiline">
          <div class="column is-6">
            <div class="field">
              <label class="label">Years (Living at this address)<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control">
                <input :name="validationName + 'years'" v-validate="yearValidationFormulae" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'years') }" :data-vv-scope="scope" type="number" data-vv-as="years" placeholder="Years" v-mask="'##'" @focus="$event.target.select()" v-model="internalValue.years">
                <span v-show="errors.has(validationName + 'years')" class="help is-danger"><i v-show="errors.has(validationName + 'years')" class="fas fa-exclamation-triangle"></i> {{ errors.first(validationName + 'years') }}</span>
                <pop-fill-control v-if="popFillData" title="Click to copy years" :fillableValue="popFillData.years" :onFillAction="onRestoreYears"></pop-fill-control>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Months (Living at this address)<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control">
                <input :name="validationName + 'months'" v-validate="monthValidationFormulae" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'months') }" :data-vv-scope="scope" type="number" data-vv-as="months" placeholder="Months" v-mask="'##'" @focus="$event.target.select()" v-model="internalValue.months">
                <span v-show="errors.has(validationName + 'months')" class="help is-danger"><i v-show="errors.has(validationName + 'months')" class="fas fa-exclamation-triangle"></i> {{ errors.first(validationName + 'months') }}</span>
                <pop-fill-control v-if="popFillData" title="Click to copy months" :fillableValue="popFillData.months" :onFillAction="onRestoreMonths"></pop-fill-control>
              </div>
            </div>
          </div>
          <div class="column is-3">
            <button-list-selector
              validateAs="ownership"
              label="Do you Own or Rent?"
              :required="true"
              :availableValues="definedTypes.ownershipTypes.options"
              :scope="scope"
              :useValidator="useValidator"
              v-model="selectedOwnershipType">
            </button-list-selector>
          </div>
          <div class="column is-3" :style="!isMobile ? 'padding-top: 59px;' : ''">
            <div class="field">
              <div class="control has-icons-left">
                <b-checkbox
                  :native-value="false"
                  name="isPrimary"
                  type="is-info"
                  v-model="internalValue.isPrimary">
                  Is Primary Address?
                </b-checkbox>
              </div>
            </div>
          </div>
          <div class="column is-3">
            <div class="field">
              <label class="label">Cost per month?<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control has-icons-left">
                <money :name="validationName + 'rate'" :disabled="noRepayment" v-validate="{ 'decimal': true, 'required': true, 'min_value': 0.00, 'max_value': 99999.00 }" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'rate') }" :data-vv-scope="scope" data-vv-as="cost" type="text" placeholder="Cost" v-bind="$globalMoneyFormat" v-model="internalValue.rate"></money>
                <span v-show="errors.has(validationName + 'rate')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'rate')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'rate') }}
                </span>
                <span class="icon is-small is-left">
                  <i class="fas fa-dollar-sign"></i>
                </span>
              </div>
            </div>
          </div>
          <div class="column is-3" :style="!isMobile ? 'padding-top: 59px;' : ''">
            <div class="field">
              <div class="control has-icons-left">
                <b-checkbox
                  :native-value="false"
                  name="noRepayment"
                  type="is-info"
                  v-model="noRepayment">
                  No Mortage
                </b-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import VueGoogleAutocomplete from 'vue-google-autocomplete'
import ButtonListSelector from '@/components/generic/ButtonListSelector'
import PopFillControl from '@/components/generic/PopFillControl'

import { createNamespacedHelpers } from 'vuex'
const mapConfigGetters = createNamespacedHelpers('config').mapGetters

export default {
  name: 'AddressCapture',
  components: {
    // 'google-search': VueGoogleAutocomplete,
    'button-list-selector': ButtonListSelector,
    'pop-fill-control': PopFillControl
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: ' '
    },
    required: {
      type: Boolean,
      default: false
    },
    addressIndex: {
      type: Number,
      default: 0
    },
    scope: {
      type: String,
      default: ''
    },
    verification: {
      type: Boolean,
      default: false
    },
    supplierVerification: {
      type: Boolean,
      default: false
    },
    originalAddressList: {
      type: Array,
      default: () => []
    },
    useValidator: {
      type: Object,
      default: null
    },
    isSpouse: {
      type: Boolean,
      default: false
    },
    popFillData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isMobile: window.innerWidth <= 700,
      instanceName: this.$uuid.v4(),
      internalValue: null,
      selectedOwnershipType: null,
      selectedState: null,
      regEx: /([^\w ]|_)/g,
      noRepayment: false,
      previousCustomerAddresses: [],
      selectedAddress: null
    }
  },
  computed: {
    ...mapConfigGetters(['definedTypes']),
    yearValidationFormulae: function () {
      return this.monthsNotEntered ? (this.required ? 'required|min_value:1' : '') : 'min_value:0'
    },
    monthValidationFormulae: function () {
      return this.yearsNotEntered ? (this.required ? 'required|min_value:1|max_value:12' : '') : 'min_value:0|max_value:12'
    },
    validationName: function () {
      return (this.scope) ? this.scope + '.' + this.instanceName + '.' : this.instanceName + '.'
    },
    monthsNotEntered: function () {
      return !this.internalValue.months || this.internalValue.months <= 0
    },
    yearsNotEntered: function () {
      return !this.internalValue.years || this.internalValue.years <= 0
    },
    stateOptions: function () {
      return this.definedTypes.usStateLookup.options
    },
    showRemoveAddress: function () {
      return this.addressIndex > 0
    }
  },
  methods: {
    getAddressData: function (addressData, place, id) {
      const addressComponents = place.address_components
      this.internalValue.postalCode = ''
      this.internalValue.state = ''
      this.internalValue.city = ''
      this.internalValue.country = 'United States'
      this.internalValue.gpsAddress = ''
      this.internalValue.isCopState = false

      for (var i = 0; i < addressComponents.length; i++) {
        var googleAddressType = addressComponents[i].types[0]

        if (googleAddressType === 'locality') {
          var city = addressComponents[i].short_name
          this.internalValue.city = city.replace(this.regEx, ' ')
        }

        if (!this.internalValue.city || this.internalValue.city === '') {
          var vicinity = place.vicinity
          this.internalValue.city = vicinity.replace(this.regEx, ' ')
        }

        if (googleAddressType === 'administrative_area_level_1') {
          var state = addressComponents[i].long_name
          this.internalValue.state = state
          const usState = this.definedTypes.usStateLookup.options.find((x) => x.name === state)
          this.internalValue.isCopState = usState ? usState.communityProperty : false
          this.selectedState = this.definedTypes.usStateLookup.options.find((x) => x.name === state)
        }

        if (googleAddressType === 'country') {
          // var country = addressComponents[i].long_name
          this.internalValue.country = 'United States'
        }

        if (googleAddressType === 'postal_code') {
          var postalCode = addressComponents[i].short_name
          this.internalValue.postalCode = postalCode
        }
      }

      if (addressData.latitude && addressData.longitude) {
        this.internalValue.gpsAddress = addressData.latitude + ',' + addressData.longitude
      }
      this.internalValue.addressIndex = this.addressIndex
      this.$emit('input', this.internalValue)
    },
    initValues: function () {
      if (this.originalAddressList.length > 0) {
        this.previousCustomerAddresses = this.originalAddressList
      }
      if (this.value) {
        this.internalValue.country = 'United States'
        this.selectedOwnershipType = this.value.ownershipType ? this.definedTypes.ownershipTypes.options.find((x) => x.name === this.value.ownershipType)
          : this.definedTypes.ownershipTypes.options.find((x) => x.name === 'Own')
        this.selectedState = this.value.state ? this.definedTypes.usStateLookup.options.find((x) => x.name === this.value.state) : null
        if (!this.value.rate || this.value.rate === 0.00) {
          this.noRepayment = true
        }
      }
    },
    onRestoreAddress1: function () {
      this.internalValue.address1 = this.popFillData.address1
    },
    onRestoreAddress2: function () {
      this.internalValue.address2 = this.popFillData.address2
    },
    onRestoreCity: function () {
      this.internalValue.city = this.popFillData.city
    },
    onRestoreState: function () {
      this.selectedState = this.popFillData.state ? this.definedTypes.usStateLookup.options.find((x) => x.name === this.popFillData.state) : null
    },
    onRestorePostalCode: function () {
      this.internalValue.postalCode = this.popFillData.postalCode
    },
    onRestoreYears: function () {
      this.internalValue.years = this.popFillData.years
    },
    onRestoreMonths: function () {
      this.internalValue.months = this.popFillData.months
    },
    removeAddress: function () {
      this.$emit('on-remove-address', this.internalValue)
    }
  },
  watch: {
    value: function (newValue, oldValue) {
      this.internalValue = newValue
      this.initValues()
    },
    selectedAddress: function (newValue, oldValue) {
      if (newValue) {
        this.internalValue.id = newValue.id
        this.internalValue.address1 = newValue.address1
        this.internalValue.address2 = newValue.address2
        this.internalValue.postalCode = newValue.postalCode
        this.internalValue.state = newValue.state
        this.internalValue.city = newValue.city
        this.internalValue.country = 'United States'
        this.internalValue.gpsAddress = ''
        this.internalValue.isCopState = newValue.isCommunityPropertyState
        this.internalValue.isPrimary = newValue.isPrimary
        this.internalValue.years = newValue.years
        this.internalValue.months = newValue.months
        this.selectedState = newValue.state ? this.definedTypes.usStateLookup.options.find((x) => x.name === newValue.state) : null
        this.internalValue.ownershipType = newValue.ownershipType ? newValue.ownershipType : ''
        this.selectedOwnershipType = newValue.ownershipType
          ? this.definedTypes.ownershipTypes.options.find((x) => x.name === newValue.ownershipType.name)
          : this.definedTypes.ownershipTypes.options.find((x) => x.name === 'Own')
        if (!newValue.rate || newValue.rate === 0.00) {
          this.noRepayment = true
        }
      }
    },
    selectedOwnershipType: function (newValue, oldValue) {
      if (newValue) {
        this.internalValue.ownershipType = newValue
        this.$emit('state-changed', this.internalValue)
      }
    },
    selectedState: function (newValue, oldValue) {
      if (newValue) {
        const usState = this.definedTypes.usStateLookup.options.find((x) => x.name === newValue.name)
        this.internalValue.isCopState = usState ? usState.communityProperty : false
        this.internalValue.state = newValue.name
        this.$emit('input', this.internalValue)
      }
    },
    noRepayment: function (newValue, oldValue) {
      if (newValue) {
        this.internalValue.rate = 0
      } else {
        this.internalValue.rate = null
      }
    },
    'internalValue.address1': function (newValue, oldValue) {
      if (newValue) {
        this.internalValue.address1 = newValue.replace(this.regEx, ' ')
      }
    },
    'internalValue.address2': function (newValue, oldValue) {
      if (newValue) {
        this.internalValue.address2 = newValue.replace(this.regEx, ' ')
      }
    },
    'internalValue.city': function (newValue, oldValue) {
      if (newValue) {
        this.internalValue.city = newValue.replace(this.regEx, ' ')
      }

      const titleCaseVersion = (newValue) ? this.$toTitleCase(newValue) : newValue
      if (titleCaseVersion !== newValue) {
        this.internalValue.city = titleCaseVersion
      }
    },
    'internalValue.country': function (newValue, oldValue) {
      if (newValue) {
        this.internalValue.country = newValue.replace(this.regEx, ' ')
      }

      const titleCaseVersion = (newValue) ? this.$toTitleCase(newValue) : newValue
      if (titleCaseVersion !== newValue) {
        this.internalValue.country = titleCaseVersion
      }
    },
    'internalValue.isPrimary': function (newValue, oldValue) {
      if (oldValue) {
        this.$emit('primary-address-set', this.internalValue)
      }
      if (newValue) {
        this.$emit('unselect-other', this.internalValue)
      }
    },
    originalAddressList: function (newValue, oldValue) {
      if (newValue && newValue.length > 0) {
        this.previousCustomerAddresses = this.originalAddressList
      }
    }
  },
  mounted: function () {
    this.initValues()
    setTimeout(function () {
      if (this.$refs && this.$refs.address) {
        this.$refs.address.$el.setAttribute('autocomplete', 'disabled')
      }
    }, 250)
  },
  created: function () {
    this.internalValue = this.value
    if (this.useValidator) {
      this.$validator = this.useValidator
    }
  }
}
</script>

<style scoped>
  .flat-table {
    font-family: sans-serif;
    -webkit-font-smoothing: antialiased;
    font-size: 0.8rem;
    overflow: auto;
    width: 100%;
    border-collapse:separate;
    border-radius: 6px;
    -moz-border-radius:6px;
    -webkit-border-radius: 6px;
  }

  .flat-table th {
    background-color: #41b883;
    color: white;
    font-weight: normal;
    padding: 10px 15px;
  }

  .flat-table td {
    background-color: rgb(238, 238, 238);
    color: rgb(111, 111, 111);
    padding: 10px 15px;
  }

  .flat-table th:first-child {
    border-radius: 6px 0 0 0;
  }

  .flat-table th:last-child {
    border-radius: 0 6px 0 0;
  }

  .flat-table tr:last-child td:first-child {
    border-radius: 0 0 0 6px;
  }

  .flat-table tr:last-child td:last-child {
    border-radius: 0 0 6px 0;
  }

  .box {
    background-color: #f6f8fa;
  }

</style>
